var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('guests-tab',{attrs:{"entity-type":"keyGroups","entity-id":_vm.keyGroup?.id},on:{"loaded":function($event){return _vm.$emit('loaded')},"reset":function($event){return _vm.$emit('reset')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }